import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import MainLayout from '../components/MainLayout';

interface RouteProps {
  element: React.ReactNode;
  isPrivate?: boolean;
  isSurvey?: boolean;
}

const CustomRoute: React.FC<RouteProps> = ({
  isPrivate = false,
  isSurvey = false,
  element,
}) => {
  const location = useLocation();

  if (location.search?.includes('langCode')) {
    const params = new URLSearchParams(location.search);
    const langCode = params.get('langCode');
    document.documentElement.setAttribute('lang', langCode ?? 'de');
  } else {
    document.documentElement.setAttribute('lang', 'de');
  }

  const { user } = useAuth();

  if (isPrivate && !user) {
    return <Navigate to="/" state={{ from: location }} />;
  }

  if (!isPrivate && user && !isSurvey) {
    return <Navigate to="/projects" state={{ from: location }} />;
  }

  return isPrivate ? <MainLayout>{element}</MainLayout> : <>{element}</>;
};

export default CustomRoute;
